import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { getCsvReport } from 'actions/ReportsAction';

// Actions, Utils
import { getBankDeposits } from 'actions/EntityActions';
import { clearFormInput } from 'actions/FormActions';
import LOOKUP from 'constants/lookup';
import WithRouter from 'custom/withRouter';
import { bankDepositsListCrumb } from 'utils/breadcrumbInfo';

// Basic Components
import Pagination from 'screens/components/basic/Pagination';
import Grid from 'screens/components/basic/Grid';
import CardSimple from 'screens/components/basic/CardSimple';
import PageHeaderWithButton from 'screens/components/basic/PageHeaderWithButton';
import Button from 'screens/components/basic/Button';

// Advanced Components
import GenericTable from 'screens/components/advanced/GenericTable';
import SearchFields from './searchFields';

const pageName = "BankDepositList";
class BankDepositList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dialogAddBankDeposit: false,
      activePage: 1,
      itemsPerPage: 10,
      orderBy: 'DESC',
      sortBy: 'Date'
    };

    this.sort = this.sort.bind(this);
  }

  componentWillMount() {
    this.getBankDeposits();
  }

  addBankDeposit = () => {
    this.props.navigate("/admin/bankdeposits/add");
  }

  downloadReport = () => {
    const queryParams = [];
    const branchIds = Array.isArray(this.props.branchIds)? this.props.branchIds.join(","): this.props.loggedBranch;
    queryParams.push(`branchIds=${branchIds}`);
    if (this.props.type != null) queryParams.push(`type=${encodeURIComponent(this.props.type)}`);
    if (this.props.startDate != null) queryParams.push(`startDate=${encodeURIComponent(this.props.startDate)}`);
    if (this.props.endDate != null) queryParams.push(`endDate=${encodeURIComponent(this.props.endDate)}`);
    if (this.props.depositDate != null) queryParams.push(`depositDate=${encodeURIComponent(this.props.depositDate)}`);
    if (this.props.amount !== 0) queryParams.push(`amount=${encodeURIComponent(this.props.amount)}`);
    if (this.props.referenceCode) queryParams.push(`referenceCode=${encodeURIComponent(this.props.referenceCode)}`);
    queryParams.push(`orderBy=${encodeURIComponent(this.state.orderBy)}`);
    queryParams.push(`sortBy=${encodeURIComponent(this.state.sortBy)}`);
    const query = queryParams.join("&");
    this.props.getCsvReport(`reports/excel/GetBankDepositCSV?${query}`, "bankDeposits");
  }
  editBankDeposit = (id) => {
    this.props.navigate(`/admin/bankdeposits/edit/${id}`);
  }

  changePage = (e) => {
    this.resetPagination(e);
    this.getBankDeposits(e);
  }

  search = () => {
    this.setState(pState => {
      return {
        ...pState,
        activePage: 1
      };
    }, this.getBankDeposits);
  }

  cleanSearch = () => {
    this.props.clearFormInput(`${pageName}DepositDateFilter`);
    this.props.clearFormInput(`${pageName}StartDateFilter`);
    this.props.clearFormInput(`${pageName}EndDateFilter`);
    this.props.clearFormInput(`${pageName}AmountFilter`);
    this.props.clearFormInput(`${pageName}CoinOrderFilter`);
    this.props.clearFormInput(`${pageName}TipsFilter`);
    this.props.clearFormInput(`${pageName}ReferenceFilter`);
    this.props.clearFormInput(`${pageName}BranchIds`); 

    this.setState(pState => {
      return {
        ...pState,
        activePage: 1,
        sortBy: "Date",
        orderBy: "DESC"
      };
    }, () => this.getBankDeposits());
  }

  getBankDeposits = (page) => {
    this.props.getBankDeposits({
      branchId: this.props.branchId || 0,
      branchIds: Array.isArray(this.props.branchIds) ? this.props.branchIds.join(",") : this.props.loggedBranch,
      depositDate: this.props.depositDate|| null,
      startDate: this.props.startDate|| null,
      endDate: this.props.endDate|| null,
      amount: this.props.amount != 0 ? this.props.amount : null,
      coinOrder: this.props.coinOrder != 0 ? this.props.coinOrder : null,
      tips: this.props.tips != 0 ? this.props.tips : null,
      referenceCode: this.props.referenceCode || null,
      isHightide: this.props.isHightide,
      orderBy: this.state.orderBy,
      sortBy: this.state.sortBy,
      page: page || this.state.activePage,
      itemsPerPage: this.state.itemsPerPage
    });
  }

  resetPagination = (page) => {
    this.setState({ activePage: page ? page : 1 });
  }

  sort(sortBy) {
    this.setState(prevState => {
      return {
        ...prevState,
        orderBy: prevState.orderBy === 'DESC' ? 'ASC' : 'DESC',
        sortBy: sortBy
      }
    }, this.getBankDeposits);
  }

  render() {
    const listBankDeposits = (this.props.bankDeposits || []).map((item) => {
      return {
        depositDate: (<Link to={`/admin/bankdeposits/edit/${item.id}`}>{moment(item.depositDate).format('YYYY-MM-DD')}</Link>),
        amount: `$ ${item.amount ? item.amount.toFixed(2) : '0.00'}`,
        coinOrder: `$ ${item.coinOrder ? item.coinOrder.toFixed(2) : '0.00'}`,
        tips: `$ ${item.tips ? item.tips.toFixed(2) : '0.00'}`,
        employeeId : item.employeeId,
        employeeName: item.employeeFullName,
        isHightide: item.isHightide ,
        // user: item.logUserId,
        referenceCode: item.referenceCode,
        cashSales: `$ ${item.cashSales ? item.cashSales.toFixed(2) : '0.00'}`,
        cashVariance: `$ ${item.cashVariance ? item.cashVariance.toFixed(2) : '0.00'}`,
        icons: (<div className="row">
          <div className="btn-group" role="group">
            <Button
              type="IconEditButton"
              mini={true}
              onTouchTap={() => this.editBankDeposit(item.id)} />
          </div>
        </div>)
      };
    });

    const isHightide = this.props.isHighTide;
    const filteredColumns = (!isHightide)? LOOKUP.bankdeposits.tableColumns : LOOKUP.bankdeposits.tableColumns.filter(col => col.key !== 'tips');
    return (
      <Grid headerContent={bankDepositsListCrumb} >
        <PageHeaderWithButton title={LOOKUP.menu.admin.items.bankdeposits.text}>
          <Button primary={true}
            type="AddButton"
            mini={true}
            className="bg-light-green"
            label="Add Bank Deposit"
            onTouchTap={this.addBankDeposit} />
        </PageHeaderWithButton>
        <CardSimple>
          <SearchFields
            downloadReport={this.downloadReport}
            pageName={pageName}
            cleanSearch={this.cleanSearch}
            search={this.search}
            branchOptions={this.props.branchOptions}
           defaultBranchValues={this.props.defaultBranchValues}
          />
        </CardSimple>
        <CardSimple>
          <GenericTable
            compName="bankDepositsListTable"
            multiSelectable={false}
            enableSelectAll={false}
            displaySelectAll={false}
            adjustForCheckbox={false}
            displayRowCheckbox={false}
            selectable={false}
            columns={filteredColumns}
            rows={listBankDeposits}
            orderBy={this.state.orderBy}
            sortBy={this.state.sortBy}
            sort={this.sort}
            stripedRows={true}
          />
          <Pagination
            length={this.props.bankDepositsTotal || 0}
            itemsPerPage={this.state.itemsPerPage}
            activePage={this.state.activePage}
            onPageChange={this.changePage}
            maxButtons={4}
          />
        </CardSimple>
      </Grid>
    );
  }
}

function mapStatetoProps(state) {
const branches = state.common.userBranches || [];
const branchOptions = branches.map(item => ({
  text: item.name,
  value: item.id.toString()
}));
const defaultBranchId = state.common.branchId?.toString();
const defaultBranch = branches.find(b => b.id.toString() === defaultBranchId);
const defaultBranchValues = defaultBranch ? [{ text: defaultBranch.name, value: defaultBranchId }] : [];
const appSettings = state.common.applicationSettings || {};
  return {
    bankDeposits: state.entity.bankDeposits ? state.entity.bankDeposits.items : [],
    bankDepositsTotal: state.entity.bankDeposits ? state.entity.bankDeposits.totalItems : 0,
    depositDate: state.form["BankDepositListDepositDateFilter"] ? moment(state.form["BankDepositListDepositDateFilter"]).format('YYYY-MM-DD') : null,
    startDate: state.form["BankDepositListStartDateFilter"] ? moment(state.form["BankDepositListStartDateFilter"]).format('YYYY-MM-DD') : null,
    endDate: state.form["BankDepositListEndDateFilter"] ? moment(state.form["BankDepositListEndDateFilter"]).format('YYYY-MM-DD') : null,
    amount: state.form["BankDepositListAmountFilter"] != '0.00' ? state.form["BankDepositListAmountFilter"] : null,
    user: state.form["BankDepositListUserFilter"],
    referenceCode: state.form["BankDepositListReferenceFilter"],
    branchId: state.common.branchId,
    branchIds: state.form["BankDepositListBranchIds"] || [state.common.branchId] || [],
    coinOrder: state.form["BankDepositListCoinOrderFilter"] != '0.00' ? state.form["BankDepositListCoinOrderFilter"] : null,
    tips: state.form["BankDepositListTipsFilter"] != '0.00' ? state.form["BankDepositListTipsFilter"] : null,
    branches,
    branchOptions,
    isHighTide: appSettings.isHighTide ,
    defaultBranchValues,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getBankDeposits: (model) => dispatch(getBankDeposits(model)),
    getCsvReport: (url, name) => dispatch(getCsvReport(url, name)),
    clearFormInput: (name) => dispatch(clearFormInput(name))
  };
}

export default connect(mapStatetoProps, mapDispatchToProps)(WithRouter(BankDepositList));
